import { flipJustification, flipLabelPlacement, TrussEnvelope } from '@paragon/contract-library';

export type FlippableTrussEnvelope = Partial<
  Pick<
    TrussEnvelope,
    | 'leftPoint'
    | 'rightPoint'
    | 'leftOverhang'
    | 'rightOverhang'
    | 'justification'
    | 'leftBevelCut'
    | 'rightBevelCut'
    | 'leftEndConnectionOverride'
    | 'rightEndConnectionOverride'
    | 'orderedTopCuts'
    | 'orderedBottomCuts'
    | 'labelPlacement'
  >
>;

export const flipTrussEnvelope = <T extends FlippableTrussEnvelope>(envelope: T): T => ({
  ...envelope,
  leftPoint: envelope.rightPoint,
  rightPoint: envelope.leftPoint,
  leftOverhang: envelope.rightOverhang,
  rightOverhang: envelope.leftOverhang,
  justification: envelope.justification && flipJustification(envelope.justification),
  leftBevelCut: envelope.rightBevelCut && {
    ...envelope.rightBevelCut,
    type: flipJustification(envelope.rightBevelCut.type),
  },
  rightBevelCut: envelope.leftBevelCut && {
    ...envelope.leftBevelCut,
    type: flipJustification(envelope.leftBevelCut.type),
  },

  leftEndConnectionOverride: envelope.rightEndConnectionOverride,
  rightEndConnectionOverride: envelope.leftEndConnectionOverride,

  orderedTopCuts: envelope.orderedTopCuts && {
    ...envelope.orderedTopCuts,
    cuts: envelope.orderedTopCuts.cuts.toReversed(),
  },
  orderedBottomCuts: envelope.orderedBottomCuts && {
    ...envelope.orderedBottomCuts,
    cuts: envelope.orderedBottomCuts.cuts.toReversed(),
  },

  labelPlacement: envelope.labelPlacement && flipLabelPlacement(envelope.labelPlacement),
});
